import { Flex, Highlight, Text } from "@mantine/core";
import "@mantine/hooks";
import { NotificationUserType } from "@prisma/client";
import dayjs from "dayjs";
import * as linkify from "linkifyjs";
import { memo, useEffect, useMemo } from "react";
import type { NotificationUserItem } from "src/service/NotificationUserApi/type";

export const NotificationMessage = ({
  notification,
  showAll,
}: {
  notification: NotificationUserItem;
  showAll?: boolean;
}) => {
  const validText = notification.message ?? "";

  const { content, newHighlight } = useMemo(() => {
    let content = notification.message ?? "";
    const highlight = notification.highlight || "";
    let newHighlight = notification.highlight;
    if (highlight?.length) {
      switch (notification.type) {
        case NotificationUserType.FUMUFUMU_WAKARU:
        case NotificationUserType.NEW_COMMENT:
        case NotificationUserType.NEW_FOLLOWER:
        case NotificationUserType.NEW_LIKE_AVATAR:
          newHighlight = notification.user.nickname;
          content = content.replace(highlight, newHighlight);
          break;
        default:
          break;
      }
    }
    return {
      content: content,
      newHighlight,
    };
  }, [notification]);

  // Find links
  const linksDetected = linkify.find(validText);

  const highlight = linksDetected
    .filter((link) => link.isLink)
    .map((link) => link.value);

  if (newHighlight) {
    highlight.push(newHighlight);
  }

  useEffect(() => {
    if (!linksDetected.length) {
      return;
    }
    const elements = document.querySelectorAll("mark");
    elements.forEach((element) => {
      const link = linksDetected.find(
        (link) => link.value === element.textContent,
      );
      if (link) {
        element.outerHTML = `
          <a href="${link.href}" style="color:#00A5B9;position: relative;" target="blank">リンク</a>
        `;
      }
    });
  }, [linksDetected]);

  return (
    <Flex w={"100%"} direction="column" align={"flex-start"}>
      <Highlight
        lineClamp={showAll ? undefined : 3}
        highlightColor="#00A5B9"
        highlightStyles={() => {
          return {
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          };
        }}
        highlight={highlight}
      >
        {content}
      </Highlight>

      <Text size={"xs"} opacity={0.7}>
        {dayjs(notification.createdAt).format("MM/DD hh:mm")}
      </Text>
    </Flex>
  );
};

export const NotificationMessageMemo = memo(NotificationMessage);
